import { useIntl } from 'react-intl';

const useContent = () => {
	const intl = useIntl();

	const formatMessage = (descriptor, values) =>
		intl.formatMessage(descriptor, values);

	return {
		formatMessage,
	};
};

export default useContent;